import { Card, Col, Row, Table,  Button } from 'antd'
import React, { useEffect, useState } from 'react'
import './AddShift.css'
import { BsPencil } from 'react-icons/bs';
import { StopOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from "react-router-dom";
import ShiftForm from './ShiftForm';
import { AddShifts, BASE_URL, DeleteShifts, FetchShifts, UpdateShifts } from '../../utils/constant';
// import { Button } from "antd";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { useDispatch, useSelector } from 'react-redux';
import SignUpSidebar from '../../common/SignUpSidebar';
import { setShft } from '../../store/slices/shiftSlice';
import ModalConfirm from '../../common/modalConfirm';
import Right from '../../assets/icons/right.svg';
import Left from '../../assets/icons/left.svg';
function AddShift() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [modalDeleteShiftVisible, setModalDeleteShiftVisible] = useState(false);
    const [deleteShiftData, setDeleteShiftData] = useState(null);

    const deleteShift = (params) => {
      setModalDeleteShiftVisible(true);
      setDeleteShiftData(params)      
    };
    const handleOk = (params) => {
      console.log('deleteDepartment')

      handleDelete(params)     
      setModalDeleteShiftVisible(false);
    };
    const handleCancel = () => {
      setModalDeleteShiftVisible(false);
    };
    const capitalizeFirstLetter = (str) => {
      return str?.replace(/\b\w/g, (char) => char.toUpperCase());
    };
    const [formVisible, setFormVisible] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [shiftsData, setShiftsData] = useState([]);
    const {
      companyName = "",
      firstName = "",
      lastName = "",
      email = "",
      phoneNumber = "",
      aadharNumber = "",
    } = useSelector((state) => state.signUp.signUpDetails);
    const handlecompany = () => {
        navigate('/profileaddstaff');
    }
    const addcompany = () => {
        navigate('/designation');
    }

    const showForm = (item) => {
        // setEditItem(item);
        setFormVisible(true);
      };
    
      const hideForm = () => {
        console.log('cancel')
        setFormVisible(false);
        setEditItem(null);
      };
    
      useEffect(() => {
        getShiftsList();
      }, []);
      const getShiftsList = async () =>{
        const token = localStorage.getItem('authToken');
      
        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${FetchShifts}`, {
            method: "POST",
             headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify({
              requiredActiveUserCount:true
            }),
          });
          
          if (response.ok) {
            const data = await response.json();
            const activeShifts = data.data.filter(item => item.isActive);
            console.log('department',data)
            setShiftsData(activeShifts)
            const newArray = activeShifts.map((item) => ({
              value: item.shiftFullName,
              key: item.shiftId
            }));
            
            sessionStorage.setItem('shift', JSON.stringify(newArray));
            dispatch(setShft(newArray));
        
          
          } else {
            const data = await response.json();
            console.log('shiftserr',data)
            toast.error(data.errorMessage, {
              position: toast.POSITION.TOP_RIGHT,
            });
            
          }
        };
        await fetchData();
      }

      const updateShift = (data) => {
        const token = localStorage.getItem('authToken');
 
console.log('FinalUpdateShifts',data)
  const fetchData = async () => {
    const response = await fetch(`${BASE_URL}/${UpdateShifts}`, {
      method: "POST",
       headers: {
                'Content-Type': 'application/json',
                'Authorization': `${token}`,
                
              },
      body: JSON.stringify(data),
    });
    
    if (response.ok) {
      const data = await response.json();
      console.log('Shifts',data)
      getShiftsList();
      // setLocations(data.data)
      // setLocationTitle(`Location ${data.data.length + 1}`);
    } else {
      const data = await response.json();
      console.log('Shiftserr',data)
      toast.error(data.errorMessage, {
        position: toast.POSITION.TOP_RIGHT,
      });
      
    }
  };
   fetchData();
      }
      const addShift = (data) => {

        const token = localStorage.getItem('authToken');
        const FinalAdddesignation = {
          shifts : [data]
      }
      console.log('FinalAddShifts',FinalAdddesignation)
        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${AddShifts}`, {
            method: "POST",
             headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify(FinalAdddesignation),
          });
          
          if (response.ok) {
            const data = await response.json();
            console.log('Shifts',data)
            getShiftsList();
           
          } else {
            const data = await response.json();
            console.log('Shiftserr',data)
            toast.error(data.errorMessage, {
              position: toast.POSITION.TOP_RIGHT,
            });
            
          }
        };
         fetchData();
      }
      const handleAddOrUpdate = (data) => {
        if(data?.shiftId){
          updateShift(data)
        }else{
          addShift(data)
        }
        // Implement your add/update logic here using the form data
        console.log('Add/Update Shift:', data);
   setEditItem(null)
   hideForm()
      };

    
    function formatTime(milliseconds) {
        const hours = Math.floor(milliseconds / 3600000);
        const minutes = Math.round((milliseconds % 3600000) / 60000);
      
        if (hours > 0) {
          return `${hours}:${minutes < 10 ? '0' : ''}${minutes} H`;
        } else {
          return `${minutes} m`;
        }
      }
      function formatTimeWithAMPM(milliseconds) {
        const hours = Math.floor(milliseconds / 3600000);
        const minutes = Math.round((milliseconds % 3600000) / 60000);
      
        const formattedHours = hours % 12 || 12;
        const ampm = hours >= 12 ? 'PM' : 'AM';
      
        return `${formattedHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
      }
      const handleDelete = async (shiftsId) => {
        const token = localStorage.getItem('authToken');
      
        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${DeleteShifts}`, {
            method: "POST",
             headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify({
              shiftId:shiftsId
            }),
          });
          
          if (response.ok) {
            const data = await response.json();
            console.log('designation',data)
            getShiftsList();
      
          
          } else {
            const data = await response.json();
            console.log('departmenterr',data)
            toast.error(data.errorMessage, {
              position: toast.POSITION.TOP_RIGHT,
            });
            
          }
        };
        await fetchData();
      }
      const handleEdit = (shifts) => {
        console.log('shiftsedit',shifts)
        // form.resetFields(); // Reset the form
        // form.setFieldsValue(shifts)
        setEditItem(null); 
        setEditItem(shifts);
        showForm();
      };
    const columns = [
        {
          title: 'Shift ID',
          dataIndex: 'shiftId',
          width: '120px'
        },
        {
          title: 'Shift Short Name',
          dataIndex: 'shiftShortName',
          width: '140px'
        },
        {
          title: 'Shift Full Name',
          dataIndex: 'shiftFullName',
          width: '120px'
        },
        {
          title: 'Shift Description',
          dataIndex: 'shiftDescription',
          width: '140px',
        },
        {
          title: 'Time',
          dataIndex: 'time',
          width: '120px',
          ellipsis: true,
        },
        // {
          //   title: 'Start Time',
          //   dataIndex: 'shiftStartTime',
          // },
          // {
            //   title: 'End Time',
            //   dataIndex: 'shiftEndTime',
            // },
            {
              title: 'Min Working Hours',
              dataIndex: 'shiftMinWorkingHrs',
              width: '140px',
            },
            {
              title: 'Late/Early Time',
              dataIndex: 'shiftLateEarlyTime',
              width: '140px',
            },
            {
              title: 'Less Time After',
              dataIndex: 'shiftLessTimeAfter',
              width: '120px',
            },
            {
              title: 'HD Limits ',
              dataIndex: 'hdLimits',
              width: '100px',
            },
            // {
        //   title: 'HD Limits Start',
        //   dataIndex: 'shiftHDLimitsStart',
        // },
        // {
        //   title: 'HD Limits End',
        //   dataIndex: 'shiftHDLimitsEnd',
        // },
        {
          title: 'OT Enable',
          dataIndex: 'shiftOTEnable',
          width: '100px',
        },
        {
          title: 'Mark OT After',
          dataIndex: 'shiftMarkOTAfter',
          width: '120px',
        },
        
        {
          title: 'Actions',
          dataIndex: 'actions',
          width: '100px',
        },
      ];
      
      const tableData = shiftsData.map((item, index) => ({
        key: index,
        shiftId: (
          <div className='truncate'>
            {item.shiftId}
          </div>
        ),
        shiftShortName: capitalizeFirstLetter(item.shiftShortName),
        shiftFullName: capitalizeFirstLetter(item.shiftFullName),
        shiftDescription: (
          <div className='truncate'>
            {capitalizeFirstLetter(item.shiftDescription)}
          </div>
        ),
        time: (
          <div>
            <div>{` ${formatTimeWithAMPM(item.shiftStartTime)}`}</div>
            <p>|</p>
            <div>{` ${formatTimeWithAMPM(item.shiftEndTime)}`}</div>
          </div>
        ),
  //       shiftStartTime: formatTimeWithAMPM(item.shiftStartTime),
  // shiftEndTime: formatTimeWithAMPM(item.shiftEndTime),
  shiftMinWorkingHrs: formatTime(item.shiftMinWorkingHrs),
  shiftLateEarlyTime: formatTime(item.shiftLateEarlyTime),
  shiftLessTimeAfter: formatTime(item.shiftLessTimeAfter),
  hdLimits: (
    <div>
      <div>{` ${formatTime(item.shiftHDLimitsStart)}`}</div>
      <p>|</p>
      <div>{` ${formatTime(item.shiftHDLimitsEnd)}`}</div>
    </div>
  ),
  // shiftHDLimitsStart: formatTime(item.shiftHDLimitsStart),
  // shiftHDLimitsEnd: formatTime(item.shiftHDLimitsEnd),
  shiftOTEnable: 
  (
    <span style={{ color: item.shiftOTEnable ? 'green' : 'red' }}>
      {item.shiftOTEnable ? 'Yes' : 'No'}
    </span>
  ),
  shiftMarkOTAfter: formatTime(item.shiftMarkOTAfter),

        actions: (
          <div className="inline-flex mb-1 mx-auto">
            {!item?.isAssigned && 
            <>
              <span className='shi-pen'><BsPencil onClick={() => handleEdit(item)}/></span>
              <span className='shi-not ml-2'><StopOutlined onClick={() => deleteShift(item?.shiftId)}/></span>
            </>
            }
          </div>
        ),
      }));
    const scroll = { x: 1300 };
    return (
        <>
                      <ToastContainer position="top-right" autoClose={2000} />

            {/* <Col lg={9}>
                <div className="shift-left-back">
                <p className='profile-add-lorem-titla'>{companyName}</p>
                        <p className='profile-add-name'> {firstName} {' '} {lastName}</p>
                    <div className='shift-car-con'>
                        <Card
                            className='shift-car-back'
                            style={{
                                width: 200,
                                height: 80,
                                fontSize: '12px',
                                fontWeight: 'bold',
                                color: '#60626F',
                            }}
                        >
                            <p className='shift-containt'>Aadhar No.:{aadharNumber}</p>
                            <p className='shift-containt'>Phone No.:{phoneNumber}</p>
                            <p className='shift-containt'>Email:{email}</p>
                        </Card>
                    </div>
                    <div className='shift-sub-topic'>
                        <p className='shift-comapny-topic mt-1'><ClockCircleFilled className='shift-comany-icon' />Company Locations</p>
                        <p className='shift-comapny-topic mt-2'><CheckCircleFilled className='shift-comany-icon1' />Department & Designation</p>
                        <p className='shift-comapny-topic mt-2'><CheckCircleFilled className='shift-comany-icon1' />Shifts</p>
                        <p className='shift-comapny-topic mt-2'><CheckCircleFilled className='shift-comany-icon1' />Add Staff</p>
                    </div>
                </div>
            </Col> */}
            <div className="h-full">
        <Row className="2xl:h-full xl:h-auto">
            <SignUpSidebar isShift={ true} location={location.pathname} />
            <Col lg={14} className="bg-[#F5FBFE] h-full text-base overflow-auto">
                <div className='flex flex-col pt-10'>
                    <div className='font-bold text-[28px] text-center mt-3 mb-4'>Shifts</div>
                    <div className='desig-org-table'>
                        <Table columns={columns} className='tableSlimScrollBar [&_.ant-table]:bg-transparent [&_td]:!text-sm [&_td]:!font-normal [&_td]:!leading-none [&_tbody_.ant-table-measure-row]:hidden' dataSource={tableData} pagination={false} scroll={scroll}/>
                    </div>
                    <div className='add-center'>
              <Button onClick={() => showForm(null)} className='h-10 border !border-[#00305F] text-[#00305F] rounded-full hover:bg-[#00305F] hover:!text-white px-4 !outline-none'><span className='font-sbold text-sm'>+Add More Shifts</span></Button>
            

              {/* <p className='depart-add-plush'>+Add More Company</p> */}
            </div>
              <div className='flex gap-2 justify-end px-5 mt-5'>
                <img src={Left} onClick={addcompany} className='w-12 cursor-pointer'/>
                <img src={Right} onClick={handlecompany} className='w-12 cursor-pointer'/>
              </div>
            </div>
            </Col>
            </Row>
      </div>
            <ShiftForm
        visible={formVisible}
        onCancel={hideForm}
        onAddOrUpdate={handleAddOrUpdate}
        initialValues={editItem}
        isEdit={editItem !== null}
        // onEdit={handleEdit}
      />
        <ModalConfirm
        visible={modalDeleteShiftVisible}
        onOk={() => handleOk(deleteShiftData)}
        onCancel={handleCancel}
        title="Delete"
        content="Are you sure you want to delete?"
      />
        </>
    )
}

export default AddShift